import React from 'react'

import { useSelector } from 'react-redux'

import type { RecipeUUID } from '@library/menu-service'

import { useRecipe } from 'hooks/menu-recipes/useRecipe'
import { DetailContent } from 'routes/Menu/MenuExperience/Detail/DetailContent'
import { useRecipeDetailData } from 'routes/Menu/components/Detail/hooks/useRecipeDetailData'
import { getBasketDate, getBasketMenuUuid, getBasketRecipeNumPortionsForId } from 'selectors/basket'

interface RecipeDetailProps {
  onClose: () => void
  onSelectRecipe?: (recipeId: RecipeUUID) => void
  recipeId: RecipeUUID
}

export const RecipeDetail = ({ onClose, onSelectRecipe, recipeId }: RecipeDetailProps) => {
  const deliveryDate = useSelector(getBasketDate)
  const menuId = useSelector(getBasketMenuUuid)
  const numPortions = useSelector(getBasketRecipeNumPortionsForId(recipeId))
  const menuRecipe = useRecipe(recipeId)

  const { loading, recipe, error, reload } = useRecipeDetailData({
    menuId,
    recipeUuid: recipeId,
    numPortions,
    deliveryDate,
  })

  if (!menuRecipe) {
    return null
  }

  return (
    <DetailContent
      uuid={menuRecipe.id}
      title={menuRecipe.name}
      loading={loading}
      error={error}
      recipe={recipe}
      reload={reload}
      onClose={onClose}
      onSelectRecipe={onSelectRecipe}
      numPortions={numPortions}
    />
  )
}
